<template>
    <div class="emotional-question">
        <label v-bind:class="{ error: valid === false, valid: valid === true }"
            ><slot name="label"></slot
        ></label>
        <div class="emotions clearfix" v-if="settings.icon !== 'star'">
            <div class="less">-</div>
            <div
                class="emotion angry"
                @click="setValue(1)"
                v-bind:class="{
                    active: currentValue == 1,
                    inactive: currentValue !== null && currentValue !== 1,
                }"
            >
                <span class="icon icon-angry"></span>
            </div>
            <div
                class="emotion sad"
                @click="setValue(2)"
                v-bind:class="{
                    active: currentValue == 2,
                    inactive: currentValue !== null && currentValue !== 2,
                }"
            >
                <span class="icon icon-sad"></span>
            </div>
            <div
                class="emotion neutral"
                @click="setValue(3)"
                v-bind:class="{
                    active: currentValue == 3,
                    inactive: currentValue !== null && currentValue !== 3,
                }"
            >
                <span class="icon icon-neutral"></span>
            </div>
            <div
                class="emotion happy"
                @click="setValue(4)"
                v-bind:class="{
                    active: currentValue == 4,
                    inactive: currentValue !== null && currentValue !== 4,
                }"
            >
                <span class="icon icon-happy"></span>
            </div>
            <div
                class="emotion very-happy"
                @click="setValue(5)"
                v-bind:class="{
                    active: currentValue == 5,
                    inactive: currentValue !== null && currentValue !== 5,
                }"
            >
                <span class="icon icon-very-happy"></span>
            </div>
            <div class="more">+</div>
        </div>
        <div class="stars clearfix" v-else>
            <div
                class="star"
                @click="setValue(1)"
                v-bind:class="{
                    active: currentValue >= 1,
                    inactive: currentValue !== null && currentValue < 1,
                }"
            >
                <span class="icon">★</span>
            </div>
            <div
                class="star"
                @click="setValue(2)"
                v-bind:class="{
                    active: currentValue >= 2,
                    inactive: currentValue !== null && currentValue < 2,
                }"
            >
                <span class="icon">★</span>
            </div>
            <div
                class="star"
                @click="setValue(3)"
                v-bind:class="{
                    active: currentValue >= 3,
                    inactive: currentValue !== null && currentValue < 3,
                }"
            >
                <span class="icon">★</span>
            </div>
            <div
                class="star"
                @click="setValue(4)"
                v-bind:class="{
                    active: currentValue >= 4,
                    inactive: currentValue !== null && currentValue < 4,
                }"
            >
                <span class="icon">★</span>
            </div>
            <div
                class="star"
                @click="setValue(5)"
                v-bind:class="{
                    active: currentValue >= 5,
                    inactive: currentValue !== null && currentValue < 5,
                }"
            >
                <span class="icon">★</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "emotional-question",
    props: {
        value: {
            type: Number,
            default: null,
        },
        settings: {
            type: Object,
            default: {
                icon: "smile",
            },
        },
    },
    data: function () {
        return {
            currentValue: this.value,
            error: null,
            valid: null,
        };
    },
    methods: {
        setValue: function (value) {
            if (this.currentValue == value) {
                this.currentValue = null;
            } else {
                this.currentValue = value;
            }
            this.$emit("change", this.currentValue);
        },
        getValue: function () {
            return this.currentValue;
        },
        isValid: function () {
            this.valid = null;
            this.error = null;
            if (this.currentValue === null) {
                this.valid = false;
                this.error = this.t("question-select_option") + ".";
                return false;
            }
            this.valid = true;
            return true;
        },
        isNull: function () {
            if (this.currentValue === null) {
                return true;
            }
            return false;
        },
    },
    watch: {
        currentValue(newValue) {
            this.$emit("change", newValue);
        },
    },
};
</script>
